// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/jquery.validate.min.js'



// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

(function($) { 

  $(document).on('submit', function(e){
    if ( !options.validated ) {
      e.preventDefault();    
      if($('#commentform').valid()){
        $(e.currentTarget).trigger('submit', { 'validated': true });
      }
    }
  });
	
  $('#commentform').validate({

    rules: {
      author: {
        required: true,
        minlength: 2
      },
    
      email: {
        required: true,
        email: true
      },
    
      comment: {
        required: true,
      }
    },
    
    messages: {
      author: "Introduzca un nombre valido",
      email: "Introduzca un email valido",
      comment: "El comentario no puede estar vacio"
    },
    
    errorElement: "div",
    errorPlacement: function(error, element) {
      element.before(error);
    }
    
  });

})(jQuery)






// WEBPACK FOOTER //
// ./scripts/main.js